import React from 'react';

import { Box } from '@chakra-ui/react';

const CustomBadge = ({ children }) => {
    return (
        <Box rounded={'44px'} bg={'#1A4FD6'} width={'28px'} height={'18px'} color={'#FFFFFF'} textAlign={'center'} fontSize={'12px'} fontWeight={'400'}>{children}</Box>
    );
};

export default CustomBadge;